/** Full-page preferences (`/preferences`) — the same form as the header sheet, for deep links and no-JS-modal contexts. */
import type { RouteObject } from 'react-router';
import { lazyRoute } from '../lazy';

const PreferencesPage = lazyRoute(() => import('./PreferencesPage'));

export const preferencesRoutes: RouteObject[] = [{ path: '/preferences', element: <PreferencesPage /> }];
